export default __webpack_public_path__ + "static/media/logo-dark.22fae845.png";